export const SPARTAN_HOME_SECTION_ANCHORS = {
  hero: 'hero',
  'brand-story': 'brand-story',
  lineup: 'lineup',
  highlights: 'highlights',
  'special-offer': 'special-offer',
  'trusted-buddy': 'trusted-buddy',
  cta: 'other-services',
} as const;

export type SpartanHomeSectionAnchor =
  (typeof SPARTAN_HOME_SECTION_ANCHORS)[keyof typeof SPARTAN_HOME_SECTION_ANCHORS];

export const SPARTAN_HOME_HERO_BANNER_SECTION_ID =
  SPARTAN_HOME_SECTION_ANCHORS.hero;

export const SPARTAN_HOME_BRAND_STORY_SECTION_ID =
  SPARTAN_HOME_SECTION_ANCHORS['brand-story'];

export const SPARTAN_HOME_LINEUP_SECTION_ID =
  SPARTAN_HOME_SECTION_ANCHORS.lineup;

export const SPARTAN_HOME_HIGHLIGHT_FEATURES_SECTION_ID =
  SPARTAN_HOME_SECTION_ANCHORS.highlights;

export const SPARTAN_HOME_SPECIAL_OFFER_SECTION_ID =
  SPARTAN_HOME_SECTION_ANCHORS['special-offer'];

export const SPARTAN_HOME_TRUSTED_BUDDY_SECTION_ID =
  SPARTAN_HOME_SECTION_ANCHORS['trusted-buddy'];

export const SPARTAN_HOME_CTA_SECTION_ID = SPARTAN_HOME_SECTION_ANCHORS.cta;
